const isArrayEmpty = (arr) => (arr || []).length === 0;

export default isArrayEmpty;
